<template>
  <PageBase class="deals">
    <template #headerRight />
    <div class="deals">
      <div class="deals__navigation">
        <HdTabsMenu v-model="routeName" class="deals__navigation__wrapper" :items="menuItems" />
        <HdButton
          modifier="tertiary"
          :icon-src="refresh"
          :aria-label="$t('GENERAL.REFRESH')"
          type="button"
          @click.native="refreshPage"
        />
      </div>
      <router-view />
    </div>
  </PageBase>
</template>

<script>
// Components
import { HdTabsMenu, HdButton } from 'homeday-blocks';
import PageBase from '@/layout/PageBase.vue';
// Icons
import { warningTriangle as errorIcon } from 'homeday-assets/L';
import { refresh } from 'homeday-assets';
// Constants
import { VUEX_PERSIST_KEY } from '@/store/user/CONSTANTS';

export default {
  /* tslint:disable-next-line */
  name: 'Deals',
  components: {
    HdTabsMenu,
    PageBase,
    HdButton,
  },
  data() {
    return {
      menuItems: [
        {
          label: this.$t('WIZARD.LIST.MENU.FUTURE_DEALS'),
          value: 'futureDeals',
        },
        {
          label: this.$t('WIZARD.LIST.MENU.PAST_DEALS'),
          value: 'pastDeals',
        },
      ],
      refresh,
      errorIcon,
    };
  },
  computed: {
    routeName: {
      get() {
        return this.$route.name;
      },
      set(routeName) {
        if (routeName !== this.$route.name) {
          this.$router.push({ name: routeName });
        }
      },
    },
  },
  methods: {
    refreshPage() {
      localStorage.removeItem(VUEX_PERSIST_KEY);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.deals {
  &__navigation {
    display: flex;
    align-items: flex-end;
    margin-bottom: $sp-m;

    @include for('tablet') {
      margin-bottom: $sp-l;
    }

    &__wrapper {
      flex-grow: 1;
    }
  }
}
</style>

<!-- Overwrite HdTabsMenu styles -->
<style lang="scss">
@import '@/styles/mixins.scss';

.deals {
  &__navigation {
    &__wrapper {
      .tabs-menu__item {
        margin-right: 0;
        min-width: 49%; // Works as we're dealing with 2 items only

        @include for('mobile-only') {
          margin-right: $sp-s;
        }
      }
    }
  }
}
</style>
